import {
  ExclamationCircleFilled,
  LeftOutlined,
  WarningFilled
} from '@ant-design/icons';
import {Button} from '@ds/components';
import {cn} from '@ds/helpers';

import type {ActionCardData, ScoreType} from '../../types';

type UrgentActionListProps = {
  messages: ActionCardData[];
  onActionClick: (type: ScoreType) => void;
};

const ACTION_LABELS: Record<ScoreType, string> = {
  atp: 'مشاهده موجودی لحظه‌ای',
  ptk: 'مشاهده قیمت‌های غیرمنصفانه',
  penetration: 'مشاهده موجودی لحظه‌ای'
};

const isScoreType = (type?: string): type is ScoreType =>
  type === 'atp' || type === 'ptk' || type === 'penetration';

const UrgentActionList: React.FC<UrgentActionListProps> = ({messages, onActionClick}) => {
  return (
    <section className="flex flex-col gap-2.5 px-4 py-4">
      <header className="flex flex-col gap-1">
        <h2 className="text-subtitle-md text-gray-09">نیازمند اقدام سریع</h2>
        <p className="text-body-sm text-gray-06">
          با رسیدگی به این موارد از کاهش امتیاز جلوگیری کنید.
        </p>
      </header>

      <div className="flex flex-col gap-2.5">
        {messages.map((message, index) => {
          const isDanger = message.priority <= 2;
          const actionType = isScoreType(message.type) ? message.type : undefined;

          return (
            <article
              key={`${message.type ?? 'message'}-${index}`}
              className={cn(
                'flex flex-col gap-2.5 rounded-lg p-2.5',
                isDanger ? 'bg-destructive-surface' : 'bg-yellow-soft'
              )}
            >
              <div className="flex items-center gap-2.5 text-body-sm-emphasis text-gray-09">
                {isDanger ? (
                  <ExclamationCircleFilled aria-hidden className="text-destructive" />
                ) : (
                  <WarningFilled aria-hidden className="text-yellow-dark-03" />
                )}
                <span>{message.title}</span>
              </div>
              <p className="pr-7.5 text-body-sm text-gray-08">{message.body}</p>
              {actionType && (
                <Button
                  className="self-end px-0"
                  variant="link"
                  size="sm"
                  onClick={() => onActionClick(actionType)}
                >
                  <span className="underline">{ACTION_LABELS[actionType]}</span>
                  <LeftOutlined aria-hidden />
                </Button>
              )}
            </article>
          );
        })}
      </div>
    </section>
  );
};

export default UrgentActionList;
